// extracted by mini-css-extract-plugin
export default {"infoBlock":"disqualifiedBidsDetails_infoBlock__be5KB","infoBlockTitle":"disqualifiedBidsDetails_infoBlockTitle__f8Skn"};